
import { Box, CircularProgress } from '@mui/material'
import React from 'react'
import { useNewBookingFlowStatus } from '../../../config/featureFlags/newBookingFlow'
import WizardClassicPage from './WizardClassicPage'
import WizardMapPage from './WizardMapPage'

const CreateBookingPageSwitch: React.FC = () => {
  const status = useNewBookingFlowStatus()

  if (status === 'loading') {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress color="primary" />
      </Box>
    )
  }

  return status === 'enabled' ? <WizardMapPage /> : <WizardClassicPage />
}

export default CreateBookingPageSwitch
